<template>
  <div class="animated revealUp">
    <div class="white-wrapper" style="zoom: 0.9">
      <div class="section-title">
        {{ $t("Credit Notes") }}
      </div>
      <div class="mt-3 mb-2" style="zoom: 0.9">
        <div class="row">
          <div class="col-lg-4 col-xl-3 align-self-center mb-2">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center mb-2">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  {{ $t("To Date") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-2">
            <button
              class="btn btn-primary px-4"
              @click.prevent="getCreditNotes()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <b-form-input
              v-debounce:800="getCreditNotes"
              v-model="searchValue"
              placeholder="Search..."
            ></b-form-input>
          </div>
          <div class="d-flex"></div>
          <div class="d-flex align-items-center">
            <!-- <FilterByStatusDropdown /> -->
            <div class="mx-2 d-flex align-items-center">
              <span
                v-if="creditNotes.length > 0"
                class="mr-3 align-self-center d-flex justify-content-end align-items-center"
              >
                <div class="mx-1">{{ $t("download") }} as:</div>
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="p-0 text-decoration-none"
                  no-caret
                >
                  <template #button-content>
                    <img
                      class="mx-1"
                      src="@/assets/img/icons/excel.svg"
                      height="25"
                      width="25"
                    />
                  </template>
                  <b-dropdown-item>
                    <a
                      target="_blank"
                      @click="getCreditNotes('Y')"
                      title="Bill Wise Exports"
                      download
                    >
                      Bill Wise Exports
                    </a>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <a
                      target="_blank"
                      @click="getCreditNotes('Y', 'item')"
                      title="Item Wise Exports"
                      download
                    >
                      Item Wise Exports
                    </a>
                  </b-dropdown-item>
                </b-dropdown>
                <!-- <a
                  target="_blank"
                  @click="getCreditNotes('Y')"
                  title="Download as Excel"
                  download
                >
                  <img
                    class="mx-1"
                    src="@/assets/img/icons/excel.svg"
                    height="25"
                    width="25"
                  />
                </a> -->
              </span>
              <b-dropdown
                :text="filterButtonTitle"
                variant="dropdown-curve"
                class="ml-auto mr-3 filter-dropdown"
              >
                <b-dropdown-item
                  v-for="(status, statusIndex) in statuses"
                  :key="statusIndex"
                  v-on:click="filterStatus(status)"
                  >{{ status.name }}</b-dropdown-item
                >
              </b-dropdown>
              <b-dropdown name="listview" id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  Viewing&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
              <div>
                <b-button
                  to="generate-credit-note"
                  variant="outline-blue"
                  class="btn btn-outline-primary"
                  ><span class="fs-16 font-weight-bold">+</span> Add Credit Note
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table text-center" border="1">
          <thead>
            <tr class="bg-lightgrey">
              <th class="text-left">Date</th>
              <th class="text-left">Credit Note No.</th>
              <th class="text-left">Ref. Invoice No.</th>
              <th class="text-left">Ref. Invoice Date</th>
              <th class="text-left">Bill Type</th>
              <th class="text-left">Buyer's Name</th>
              <th class="text-left">Buyer's PAN</th>
              <th class="text-left">Total Sales</th>
              <th class="text-left">Discount</th>
              <th class="text-left">Taxable Sales</th>
              <th class="text-left">VAT</th>
              <th class="text-left">Total</th>
              <th class="text-left">Reason</th>
              <th class="text-left">View Invoice</th>
            </tr>
          </thead>

          <tbody v-if="creditNotes.length > 0">
            <template v-for="(trx, pindex) in creditNotes">
              <tr
                :key="trx.invoice_number + String(pindex)"
                :class="trx.more ? 'showBorder-up' : ''"
                :style="trx.is_refund == 'Y' ? 'color: red;' : ''"
              >
                <td class="text-left">
                  {{ trx.bill_date | dateparse }}
                </td>
                <td class="text-center">{{ trx.invoice_number }}</td>
                <td class="text-center">{{ trx.org_invoice_number }}</td>
                <td class="text-center">{{ trx.org_invoice_date }}</td>
                <td class="text-center">{{ trx.type_name }}</td>
                <td class="text-center">{{ trx.customer_name }}</td>
                <td class="text-center">{{ trx.customer_pan }}</td>
                <td class="text-right">
                  {{ currFormat(trx.total_gross_amount) }}
                </td>
                <td class="text-right">
                  {{ currFormat(trx.total_discount_amount || 0) }}
                </td>
                <td class="text-right">
                  {{ currFormat(trx.total_taxable_amount) }}
                </td>
                <td class="text-right">
                  {{ currFormat(trx.VAT) }}
                </td>
                <td class="text-right">
                  {{ currFormat(trx.total_gross_amount) }}
                </td>
                <td class="text-right">
                  {{ currFormat(trx.reason) }}
                </td>
                <td class="text-center">
                  <span
                    @click="showHideDetails(trx)"
                    class="icon-eye mr-1"
                  ></span>
                  &nbsp;
                  <span @click="onPrintHandler(trx)" class="mr-1">
                    <img
                      src="@/assets/img/icons/print.svg"
                      height="24"
                      width="24"
                    />
                  </span>
                </td>
              </tr>
              <tr
                :style="trx.more ? '' : 'display: none'"
                :key="trx.invoice_number"
                :class="trx.more ? 'showBorder-down' : ''"
              >
                <td colspan="100%">
                  <b-collapse v-model="trx.more" class="swc-report px-3">
                    <!-- LIST VIEW -->
                    <table
                      class="swc-report-table text-center"
                      style="width: 100%"
                      border="1"
                    >
                      <tr>
                        <th>Item Name</th>
                        <th>Description</th>
                        <th>Qty.</th>
                        <th>Unit</th>
                        <th>Net Price</th>
                        <th>Total Tax</th>
                        <th>Gross Price</th>
                      </tr>

                      <tbody
                        v-if="trx.items_array && trx.items_array.length > 0"
                      >
                        <tr
                          v-for="(item, itemindex) in trx.items_array"
                          :key="itemindex"
                        >
                          <td class="text-left">{{ item.item_name }}</td>
                          <td class="text-left">{{ item.description }}</td>
                          <td class="text-right">{{ item.item_qty }}</td>
                          <td class="text-left">{{ item.uom_name || "-" }}</td>
                          <td class="text-right">
                            {{ currFormat(item.net_price) }}
                          </td>
                          <td class="text-right">
                            {{ currFormat(item.tax_price) }}
                          </td>
                          <td class="text-right">
                            {{ currFormat(item.gross_price) }}
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="7">
                            <NoRecords />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-collapse>
                </td>
              </tr>
            </template>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="14">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-if="creditNotes.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import Printd from "printd";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      refund_submitted: false,
      selectedTrx: {
        invoice_number: "",
        refund_reason: "",
      },
      typeFilter: "",
      statuses: [
        {
          flag: "Refund",
          name: "Refund",
        },
        {
          flag: "Active",
          name: "Active",
        },
        {
          flag: "",
          name: "All",
        },
      ],
      filterButtonTitle: "All",
      EjsData: null,
      perPage: 10,
      isEditable: false,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],

      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",

      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      creditNotes: [],
      excelFilePath: "",
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemaList(obj);
    this.getviewingnumber();
  },
  watch: {
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    moment,
    onPrintHandler(trx) {
      let payload = {
        isPrint: "Y",
        creditNoteId: trx.cn_id,
      };
      let loader = this.$loading.show();
      CinemasService.GetCreditNoteDetails(payload)
        .then((response) => {
          if (response) {
            const { data } = response;
            if (data && data.hasOwnProperty("status") && !data.status) {
              this.$toasted.show(data.message || "Print Failed!");
            } else {
              this.EjsData = data;
              this.$nextTick(() => {
                const p = new Printd();
                if (this.$refs.onPrint && this.EjsData != null) {
                  p.print(this.$refs.onPrint, []);
                }
              });
            }
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    showHideDetails: function (trx) {
      if (trx.hasOwnProperty("more")) {
        trx.more = !trx.more;
      } else trx.more = true;

      this.creditNotes.forEach((p) => {
        if (trx.cn_id != p.cn_id) {
          p.more = false;
        }
      });

      this.$forceUpdate();
    },
    filterStatus: function (status) {
      this.filterButtonTitle = status.name;
      this.typeFilter = status.flag;
      this.onChangePagination();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCreditNotes();
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getCreditNotes();
      } else {
        this.currentPage = event;
        this.getCreditNotes();
      }
    },
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getCreditNotes(isExcelDownload = "N", exportType = "bill") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }

      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      } else if (!this.toDate) {
        return this.$toasted.show("Select To Date");
      } else if (
        moment(moment(this.fromDate).format("YYYY-MM-DD")).isAfter(
          moment(this.toDate).format("YYYY-MM-DD")
        )
      ) {
        return this.$toasted.show("From Date is Greater Than TO Date");
      } else {
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          limit: this.perPage,
          currentPage: this.currentPage,
          searchValue: this.searchValue,
          orderBy: this.orderby,
          columnName: this.columnName,
          typeFilter: this.typeFilter,
          exportType: exportType,
        };

        if (isExcelDownload == "Y") {
          payload["isExcel"] = "Y";
          payload["limit"] = null;
          payload["currentPage"] = 1;
        }

        CinemasService.GetCreditNotes(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.excelPath && isExcelDownload == "Y") {
              window.open(data.excelPath, "_blank");
            } else if (data.status && data.Records.length > 0) {
              this.creditNotes = [...data.Records];
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue = 10;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.creditNotes = [];
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      }
    },
  },
};
</script>

<style>
.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}
.swc-report-table td {
  white-space: nowrap;
}
.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
.no_border {
  border: 0px !important;
}

.showBorder-up {
  border: 1.5px solid black;
  border-bottom: 0;
}

.showBorder-down {
  border: 1.5px solid black;
  border-top: 0;
}

.refundReasonText {
  border-radius: 7px;
  border: 1px solid grey;
  padding: 5px;
  width: 100%;
}

.refundReasonText_error {
  font-weight: 500;
  font-size: 10px;
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CreditNoteComponents/CreditNoteList.vue